import { BuilderConfig } from '../../types/Builder';

import BusinessHubIndustriesStats, { Props } from './business-hub-industries-stats';

export const BusinessHubIndustriesStatsBuilderConfig = {
    name: 'Business Hub Industries Stats',
    inputs: [
        {
            name: 'stats',
            type: 'list',
            subFields: [
                {
                    name: 'icon',
                    type: 'file',
                },
                {
                    name: 'stats',
                    type: 'richText',
                    helperText:'Wrap percent character in "percent" class'
                },
                {
                    name: 'description',
                    type: 'richText',
                },
                {
                    name: 'background',
                    type: 'color',
                },
                {
                    name: 'textColor',
                    type: 'color',
                },
            ],
        },
        {
            name: 'disclaimer',
            type: 'richText',
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: BusinessHubIndustriesStats,
    config: BusinessHubIndustriesStatsBuilderConfig,
};

export default builderConfig;
